import { Union } from "../Docs/fable_modules/fable-library.3.7.1/Types.js";
import { class_type, union_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class ColumnPinningPosition extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Left", "Right", "Neither"];
    }
}

export function ColumnPinningPosition$reflection() {
    return union_type("Feliz.TanStack.Table.ColumnPinningPosition", [], ColumnPinningPosition, () => [[], [], []]);
}

export function ColumnPinningPosition__asString(this$) {
    switch (this$.tag) {
        case 0: {
            return "left";
        }
        case 1: {
            return "right";
        }
        default: {
            return "false";
        }
    }
}

export class Column_Column {
    constructor() {
    }
}

export function Column_Column$reflection() {
    return class_type("Feliz.TanStack.Table.Column.Column", void 0, Column_Column);
}

export function Column_Column_getCanPin_Z2685F962(column) {
    return column.getCanPin();
}

export function Column_Column_getIsPinned_Z2685F962(column) {
    const isPinned = column.getIsPinned();
    switch (isPinned) {
        case "left": {
            return new ColumnPinningPosition(0);
        }
        case "right": {
            return new ColumnPinningPosition(1);
        }
        default: {
            return new ColumnPinningPosition(2);
        }
    }
}

export class Column_Table {
    constructor() {
    }
}

export function Column_Table$reflection() {
    return class_type("Feliz.TanStack.Table.Column.Table", void 0, Column_Table);
}

export function Column_Table_setColumnFilter(value, column) {
    column.setFilterValue(value);
    return column;
}

export function Column_Table_pinColumn(position, column, table) {
    const positionStr = ColumnPinningPosition__asString(position);
    column.pin(positionStr);
    return table;
}

//# sourceMappingURL=Column.fs.js.map
